var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0H10.8333C12.214 0 13.3333 1.11929 13.3333 2.5V17.5C13.3333 18.8807 12.214 20 10.8333 20H2.5C1.11929 20 0 18.8807 0 17.5V2.5C0 1.11929 1.11929 0 2.5 0ZM11.25 16.25C11.4801 16.25 11.6667 16.0635 11.6667 15.8333V2.91667C11.6667 2.68655 11.4801 2.5 11.25 2.5H2.08333C1.85321 2.5 1.66667 2.68655 1.66667 2.91667V15.8333C1.66667 16.0635 1.85321 16.25 2.08333 16.25H11.25Z",
    fill: "#9684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.75002 7.5C3.28978 7.5 2.91669 7.8731 2.91669 8.33333V10.8333C2.91669 11.2936 3.28978 11.6667 3.75002 11.6667C4.21026 11.6667 4.58335 11.2936 4.58335 10.8333V8.33333C4.58335 7.8731 4.21026 7.5 3.75002 7.5Z",
    fill: "#9684FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.58333 7.5C9.1231 7.5 8.75 7.8731 8.75 8.33333V10.8333C8.75 11.2936 9.1231 11.6667 9.58333 11.6667C10.0436 11.6667 10.4167 11.2936 10.4167 10.8333V8.33333C10.4167 7.8731 10.0436 7.5 9.58333 7.5Z",
    fill: "#9684FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.66665 5.41663C6.20641 5.41663 5.83331 5.78972 5.83331 6.24996V12.9166C5.83331 13.3769 6.20641 13.75 6.66665 13.75C7.12688 13.75 7.49998 13.3769 7.49998 12.9166V6.24996C7.49998 5.78972 7.12688 5.41663 6.66665 5.41663Z",
    fill: "#9684FF"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.39a4ee93.svg";
export { ForwardRef as ReactComponent };